/*
 * Refactored
 */
import { SxProps } from '@mui/material';

export const productCardNameSX: SxProps = {
	overflow: 'hidden',
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
	textOverflow: 'ellipsis',
	marginBottom: '15px',
	minHeight: { xl: '54px', md: '38px' },
	textTransform: 'lowercase',
	'&::first-letter': {
		textTransform: 'uppercase',
	},
};

export const productCardDescriptionSX: SxProps = {
	textTransform: 'capitalize',
	overflow: 'hidden',
	display: '-webkit-box',
	WebkitLineClamp: '6',
	WebkitBoxOrient: 'vertical',
	textOverflow: 'ellipsis',
	marginBottom: '15px',
};
